import React from 'react';
import { Navigate } from 'react-router-dom';

// Compatibilidad de enlaces guardados; los lotes para terceros fueron retirados.
export default function Reconciliation() {
  return <Navigate to="/dashboard" replace />;
}